"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECP = void 0;
const SmartPlastics_1 = require("../SmartPlastics");
const echain_shared_oo_1 = require("@igus/echain-shared-oo");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
class ECP extends SmartPlastics_1.SmartPlastics {
    constructor() {
        super(...arguments);
        this.className = 'ECP';
    }
    static fromScratch() {
        return new ECP({ ArticleType: 'zubehoer', EntityId: echain_shared_oo_1.UUIDGenerator.new() });
    }
    static fromModel(model) {
        const ecp = ECP.fromScratch();
        Object.assign(ecp.model, model);
        Object.assign(model, ecp.model);
        ecp.model = model;
        return ecp;
    }
    static fromJson(args) {
        const ecp = ECP.fromScratch();
        ecp.fromJson(args);
        return ecp;
    }
    clone() {
        const model = (0, echain_shared_ts_utils_1.clonePrimitive)(this.toModel());
        return ECP.fromModel(model);
    }
    duplicate() {
        return ECP.fromModel(this.toModel());
    }
}
exports.ECP = ECP;
//# sourceMappingURL=Ecp.js.map